<template>
  <div id="orderDetail">
    <dd-header></dd-header>
    <!-- 上部タブ -->
    <div class="container_main">
    <!-- 左部サイドバー -->
    <div class="side_update">
      <div class="delivery_date">
        <h2>確定納品日</h2>
        <dl>
          <dt>希望納期日</dt>
          <dd>{{orderDetailData.shippingDeliveryDate}}</dd>
          <dt>確定納品日</dt>
          <dd>{{orderDetailData.deliveryDate}}</dd>
          <p><font color="red">{{this.updateDeliDateMessage}}</font></p>
        </dl>
        <input type="date" v-model="deliDate">
        <input type="button" value="更新" @click="onUpdateDateConfirm(1)">
      </div>
      <div class="construction_date">
        <h2>組立設置日</h2>
        <dl>
          <dt>作業希望日</dt>
          <dd>第一希望日 {{orderDetailData.constructionDate1}}</dd>
          <dd>第二希望日 {{orderDetailData.constructionDate2}}</dd>
          <dd>第三希望日 {{orderDetailData.constructionDate3}}</dd>
        </dl>
        <dl>
          <dt>組立設置日</dt>
          <dd>{{orderDetailData.replyConstructionDate}}</dd>
          <p><font class="caution">{{this.updateConstructionDateMessage}}</font></p>
        </dl>
        <input type="date" v-model="constDate">
        <input type="button" value="更新" @click="onUpdateDateConfirm(2)">
      </div>
    </div>
    <!--  メインコンテンツ  -->
    <div class="main_content">
      <div id="flex_tab">
         <!-- 上部タブ -->
         <div class="container">
           <ul class="left_tab">
             <li class="choosing_tab main_tab">
               <h3>受注表</h3>
             </li>
           </ul>
           <ul class="btn_list">
             <li class="main_btn" @click="showPreviewModal" v-bind:class="{img_disable: !isPreviewFile}" v-on:mouseover="isOnSheet(true)" v-on:mouseleave="isOnSheet(false)">
               <img :src="imgSheet" alt="preview" width="14px" height="auto">自動生成
             </li>
           </ul>
         </div>
       </div>
       <main class="flex_content">
          <ul class="status_flow">
            <li v-for="(row, index) in orderDetailData.statusListForFlow" :key="'status_flow_' + index" v-bind:class="{status_already: row.statusCode === orderDetailData.status}">
              {{row.statusName}}
            </li>
          </ul>
          <br>
          <table>
            <thead v-if="!isDelivery">
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">注文情報</font></th>
              </tr>
            </thead>
            <tbody v-if="!isDelivery">
              <tr>
                <td class="order_td" colspan="3">注文番号</td>
                <td colspan="2">{{ orderDetailData.orderNo }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">注文個別番号</td>
                <td colspan="2">{{ orderDetailData.odMgCode }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">施主名(物件名)</td>
                <td colspan="2">{{ orderDetailData.shippingName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">プランID</td>
                <td colspan="2">{{ orderDetailData.planId }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">注文日時</td>
                <td colspan="2">{{ orderDetailData.orderDate }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">決済方法</td>
                <td colspan="2">{{ orderDetailData.orderPayType }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">支払い期日</td>
                <td colspan="2">{{ orderDetailData.orderPayLimitDate }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">支払い確認日時</td>
                <td colspan="2">{{ orderDetailData.orderPayDate }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">ご請求金額</td>
                <td colspan="2">{{ orderDetailData.orderAmount }}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">商品入力情報</font></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="order_td" colspan="3">商品名</td>
                <td colspan="2">{{ orderDetailData.itemName }}</td>
              </tr>
              <tr v-if="orderDetailData.colorStyle && orderDetailData.colorStyle.colorStyleName">
                <td class="order_td" colspan="3">スタイル名</td>
                <td colspan="2">{{orderDetailData.colorStyle.colorStyleName}}</td>
              </tr>
              <tr>
                <td class="order_td" rowspan="2">1.商品寸法/フィラー</td>
                <td class="order_td" colspan="2">1-1.商品サイズ</td>
                <td colspan="2">
                  <div>
                    <span>W:{{ orderDetailData.sizeW }}mm</span>
                    <span v-if="orderDetailData.sizeW2"> W2:{{ orderDetailData.sizeW2 }}mm</span>
                  </div>
                  <div>
                    <span>H:{{ orderDetailData.sizeH }}mm</span>
                    <span v-if="orderDetailData.sizeH2"> H2:{{ orderDetailData.sizeH2 }}mm</span>
                  </div>
                  <div>
                    <span>D:{{ orderDetailData.sizeD }}mm</span>
                    <span v-if="orderDetailData.sizeD2"> D2:{{ orderDetailData.sizeD2 }}mm</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">1-2.フィラー</td>
                <td colspan="2">
                  <div>左:{{ orderDetailData.fillerLeft }}</div>
                  <div>右:{{ orderDetailData.fillerRight }}</div>
                  <div>上部:{{ orderDetailData.fillerCenter }}</div>
                </td>
              </tr>
              <tr v-if="selectColorCnt!=0">
                <td class="order_td" :rowspan="selectColorCnt">2.カラー</td>
                <td class="order_td" colspan="2">{{firstColorLabel}}</td>
                <td colspan="2">{{ firstColorValue }}</td>
              </tr>
              <tr v-if="selectColorCnt > 1">
                <td class="order_td" colspan="2">{{secondColorLabel}}</td>
                <td colspan="2">{{ secondColorValue }}</td>
              </tr>
              <tr v-if="selectColorCnt > 2">
                <td class="order_td" colspan="2">{{thirdColorLabel}}</td>
                <td colspan="2">{{ thirdColorValue }}</td>
              </tr>
              <tr>
                <td class="order_td" rowspan="2">3.追加部材</td>
                <td class="order_td" colspan="2">可動棚</td>
                <td colspan="2">{{ orderDetailData.opShelfCnt }}</td>
              </tr>
              <tr>
                <!-- TODO サイズごとに動的に項目を変更する必要あり -->
                <td class="order_td" colspan="2">フィラー</td>
                <td colspan="2">{{ orderDetailData.opFillerCnt }}</td>
              </tr>
              <tr v-if="!isDelivery">
                <td class="order_td" colspan="3">4.組立設置</td>
                <td colspan="2">{{ orderDetailData.opExFlag }}</td>
              </tr>
              <tr v-if="!isDelivery">
                <td class="order_td" colspan="3">5.受け取り搬入サービス</td>
                <td colspan="2">{{ orderDetailData.opCarryFlag }}</td>
              </tr>
            </tbody>
          </table>
          <section class="estimation" v-if="orderDetailData.researchFlg">
            <div class="order_title"><font color="ffffff">ご請求明細</font></div>
            <dd-resrch-price
              :priceData="priceData"
            />
          </section>
          <dd-order-price
            :orderPrice="orderPriceData"
            v-if="!orderDetailData.researchFlg && !isOldPriceType"
          />
          <section class="estimation">
            <div class="order_title">
              <font color="ffffff" v-if="orderDetailData.researchFlg">見積り明細</font>
              <font color="ffffff" v-if="isOldPriceType">商品金額</font>
              <font color="ffffff" v-else>商品金額(税抜)</font>
            </div>
            <dd-price-old
              :priceData="priceData"
              :dcProductCount="orderDetailData.productCount"
              :isCalcDelivery="true"
              v-if="isOldPriceType"
            />
            <dd-price
              :priceData="priceData"
              :dcProductCount="orderDetailData.productCount"
              :isCalcDelivery="true"
              v-else
            />
          </section>
          <template v-if="isBuildingResearchData">
            <dd-builresearch
              :builResrchData="builResrchData"
            />
          </template>
          <table>
            <thead v-if="!isBuildingResearchData">
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">納品先入力情報</font></th>
              </tr>
            </thead>
            <tbody v-if="!isBuildingResearchData">
              <tr>
                <td class="order_td" colspan="3">施主名（物件名）</td>
                <td colspan="2">{{ orderDetailData.shippingName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">納品先名</td>
                <td colspan="2">{{ orderDetailData.shippingBuilding }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">納品先郵便番号</td>
                <td colspan="2">{{ orderDetailData.shippingPostCode }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">納品先住所</td>
                <td colspan="2">{{ orderDetailData.shippingAddress }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">受取人氏名</td>
                <td colspan="2">{{ orderDetailData.shippingReceiverName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">受取人氏名（カナ）</td>
                <td colspan="2">{{ orderDetailData.shippingReceiverNameKana }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">受取人電話番号</td>
                <td colspan="2">{{ orderDetailData.shippingReceiverTel }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">納品希望日時</td>
                <td colspan="2">{{ getDate(orderDetailData.shippingDeliveryDate, orderDetailData.shippingDeliveryStartTime, orderDetailData.shippingDeliveryEndTime) }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">配送時の連絡事項</td>
                <td colspan="2">{{ orderDetailData.shippingNotice }}</td>
              </tr>
            </tbody>
            <thead v-if="!isBuildingResearchData">
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">配送情報</font></th>
              </tr>
            </thead>
            <tbody v-if="!isBuildingResearchData">
              <tr>
                <td class="order_td" colspan="3">配送業者名</td>
                <td colspan="2">クリナップロジスティクス</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">PF納品日</td>
                <td colspan="2">{{ orderDetailData.platformDeliveryDate }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">納品日</td>
                <td colspan="2">{{ orderDetailData.deliveryDate }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">商品個口数</td>
                <td colspan="2">{{ orderDetailData.itemCountOfUnit }}</td>
              </tr>
              <tr v-for="(pack,index) in orderDetailData.packageDataList" :key="'pack' + index">
                <td class="order_td" colspan="2" :rowspan="orderDetailData.packageDataList.length" v-if="index===0">梱包後WHD</td>
                <td class="order_td">{{ pack.objUmCode }}</td>
                <td colspan="2">{{ packagedSize(pack.width, pack.height, pack.depth, pack.value) }}</td>
              </tr>
            </tbody>
            <thead v-if="!isDelivery && !isBuildingResearchData">
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">組立設置入力情報</font></th>
              </tr>
            </thead>
            <tbody v-if="!isDelivery && !isBuildingResearchData">
              <tr>
                <td class="order_td" colspan="3">組立先郵便番号</td>
                <td colspan="2">{{ orderDetailData.structPostCd }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">組立先住所</td>
                <td colspan="2">{{ orderDetailData.structAddress }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">立会人氏名</td>
                <td colspan="2">{{ orderDetailData.structUserName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">立会人電話番号</td>
                <td colspan="2">{{ orderDetailData.structTel }}</td>
              </tr>
              <tr>
                <td class="order_td" rowspan="3">作業希望日</td>
                <td class="order_td" colspan="2">第一希望日</td>
                <td colspan="2">{{ orderDetailData.constructionDate1 }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">第二希望日</td>
                <td colspan="2">{{ orderDetailData.constructionDate2 }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">第三希望日</td>
                <td colspan="2">{{ orderDetailData.constructionDate3 }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">ご自宅のタイプ</td>
                <td colspan="2">{{ orderDetailData.homeType }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">駐車スペースの有無</td>
                <td colspan="2">{{ orderDetailData.parkingSpace }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">連絡事項</td>
                <td colspan="2">{{ orderDetailData.structMessage }}</td>
              </tr>
            </tbody>
            <thead v-if="!isDelivery">
              <tr>
                <th  class="order_th" colspan="5"><font color="ffffff">発注者情報</font></th>
              </tr>
            </thead>
            <tbody v-if="!isDelivery">
              <tr>
                <td class="order_td" colspan="3">発注者名</td>
                <td colspan="2">{{ orderDetailData.userName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">会社名</td>
                <td colspan="2">{{ orderDetailData.companyName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">所属部署</td>
                <td colspan="2">{{ orderDetailData.departmentName }}</td>
              </tr>
              <tr>
                <td class="order_td" rowspan="4">連絡先</td>
                <td class="order_td" colspan="2">郵便番号</td>
                <td colspan="2">{{ orderDetailData.postCode }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">住所</td>
                <td colspan="2">{{ orderDetailData.address }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">電話番号</td>
                <td colspan="2">{{ orderDetailData.tel }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="2">メールアドレス</td>
                <td colspan="2">{{ orderDetailData.mail }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">知ったメディア</td>
                <td colspan="2">{{ orderDetailData.infoSrcName }}</td>
              </tr>
              <tr>
                <td class="order_td" colspan="3">招待コード</td>
                <td colspan="2">{{ orderDetailData.inviteCode }}</td>
              </tr>
            </tbody>
            <thead v-if="!isDelivery">
              <tr>
                <th class="order_th" colspan="5"><font color="ffffff">ステータス更新履歴と変更</font></th>
              </tr>
            </thead>
            <tbody v-if="!isDelivery">
              <tr>
                <td class="order_td" colspan="3"></td>
                <td class="order_td">変更者または対応予定者</td>
                <td class="order_td">変更日時</td>
              </tr>
              <tr v-for="(history,index) in orderDetailData.histories" :key=index>
                <td class="order_td" colspan="3">{{ history.statusName }}</td>
                <td>{{ history.updateUserName }}</td>
                <td>{{ history.updateDate }}</td>
              </tr>
              <br>
              <tr>
                <td class="order_td" colspan="3">ステータス変更</td>
                <td>
                  <select v-if="orderDetailData.statusList && orderDetailData.statusList.length" v-model="nextStatus">
                    <option v-for="(orderStatus, index) in orderDetailData.statusList" :key= index :value="orderStatus.statusCode" >{{orderStatus.statusName}}</option>
                  </select>
                </td>
                <td style="text-align:right;">
                  <button type="submit" class="main_btn" @click="onUpdate()">更新</button>
                </td>
               </tr>
               <p><font color="red">{{this.updateMessage}}</font></p>
             </tbody>
            </table>
         </main>
         <div class="button_wrapper">
           <button class="main_btn cancel_btn" @click="cancel()">戻る</button>
         </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
// Libraries
import axios from 'axios'
import moment from 'moment'
// Module
import {API_URL, STORAGE_KEY} from '../constants/App'
import {USER_TYPE} from '../constants/Type'
import * as AppUtil from '../utils/App'
import * as Api from '../utils/Api'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
// import OrderTable from '../components/order/OrderTable'
import PriceList from '../payment/components/payment/PriceList'
import PriceListOld from '../payment/components/payment/PriceListOld'
import PriceResrchList from '../payment/components/payment/ResrchPrice'
import OrderBuilResearch from '../components/order/OrderBuilResearch'
import OrderPrice from '../payment/components/payment/OrderPrice'

export default {
  name: 'OrderDetail',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-price': PriceList,
    'dd-price-old': PriceListOld,
    'dd-resrch-price': PriceResrchList,
    'dd-builresearch': OrderBuilResearch,
    'dd-order-price': OrderPrice
  },
  props: {
    // OrderDetail: Object
  },
  data () {
    return {
      spaceJoincd: '',
      fileData: {},
      priceData: {},
      orderPriceData: {},
      isConstruct: false,
      isOldPriceType: false,
      imgEstimate: this.getImage('print/ic_estimate.svg'),
      imgSheet: this.getImage('pages/planning/icon_output.svg'),
      imgBom: this.getImage('print/ic_output.svg'),
      imgCG: this.getImage('print/ic_output.svg'),
      // pageNo: this.$route.params.pageNo == null ? 1 : this.$route.params.pageNo,
      // dataCount: this.$route.params.dataCount == null ? 16 : this.$route.params.dataCount,
      orderDetailData: {},
      nextStatus: this.nextStatus,
      orderCode: '',
      updateMessage: '',
      updateConstructionDateMessage: '',
      updateDeliDateMessage: '',
      deliDate: '',
      constDate: '',
      userType: '',
      builResrchData: {}
    }
  },
  methods: {
    isOnEstimate: function (on) {
      if (on) {
        this.imgEstimate = this.getImage('print/ic_estimate_sel.svg')
      } else {
        this.imgEstimate = this.getImage('print/ic_estimate.svg')
      }
    },
    isOnSheet: function (on) {
      if (on) {
        this.imgSheet = this.getImage('pages/planning/icon_output.svg')
      } else {
        this.imgSheet = this.getImage('pages/planning/icon_output.svg')
      }
    },
    isOnBom: function (on) {
      if (on) {
        this.imgBom = this.getImage('print/ic_output_sel.svg')
      } else {
        this.imgBom = this.getImage('print/ic_output.svg')
      }
    },
    isOnCG: function (on) {
      if (on) {
        this.imgCG = this.getImage('print/ic_output_sel.svg')
      } else {
        this.imgCG = this.getImage('print/ic_output.svg')
      }
    },
    getDate: function (date, start, end) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      if (!start || !end) {
        time += ' 時間指定なし'
      } else {
        time += start < 12 ? ' AM ' : ' PM '
        time += start + ':00'
        time += '～'
        time += end + ':00'
      }
      return time
    },
    /** 図面/製造指示書プレビュー **/
    showPreviewModal: function () {
      if (!this.isPreviewFile) {
        return
      }
      let childWindow = window.open('/#/preview?orderCode=' + this.orderDetailData.odMgCode + '&spaceJoincd=' + this.spaceJoincd, 'sheet-page', 'width=1420, height=940')
      childWindow.location.reload()
    },
    getOrderDetail: function () {
      axios.get(API_URL.ORDER + '/detail/' + this.orderCode)
        .then(response => {
          this.orderDetailData = response.data.data
          this.priceData = response.data.data.priceData
          this.orderPriceData = response.data.data.orderPriceData
          this.isConstruct = response.data.data.isConstruct
          this.isOldPriceType = response.data.data.isOldPriceType
          // this.pageNo = this.$route.params.pageNo == null ? 1 : this.$route.params.pageNo
          // this.dataCount = this.$route.params.dataCount == null ? 16 : this.$route.params.dataCount
          this.nextStatus = this.orderDetailData.nextStatus
          this.spaceJoincd = this.orderDetailData.spaceJoinCode
          this.builResrchData = response.data.data.builResrchData
        }).catch(error => {
          Api.handleError(error)
        })
    },
    updateStatus: function () {
      axios.get(API_URL.ORDER + '/detail/update/' + this.orderCode + '/' + this.nextStatus)
        .then(response => {
          if (response.data.data.errorMsg != null) {
            this.updateConstructionDateMessage = ''
            this.updateDeliDateMessage = ''
            this.updateMessage = response.data.data.errorMsg
          } else {
            this.orderDetailData = response.data.data
            // this.pageNo = this.$route.params.pageNo == null ? 1 : this.$route.params.pageNo
            // this.dataCount = this.$route.params.dataCount == null ? 16 : this.$route.params.dataCount
            this.nextStatus = this.orderDetailData.nextStatus
            this.updateMessage = 'ステータスを更新しました。'
            this.updateConstructionDateMessage = ''
            this.updateDeliDateMessage = ''
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    onUpdate: function () {
      this.updateMessage = ''
      this.updateConstructionDateMessage = ''
      this.updateDeliDateMessage = ''
      AppUtil.showModal({
        messages: ['ステータスを更新しますがよろしいですか？'],
        modalType: 'confirm',
        onOk: () => {
          this.updateStatus()
          this.updateConstructionDateMessage = ''
          this.updateDeliDateMessage = ''
        }
      })
    },
    onUpdateDateConfirm: function (param) {
      let confirmMsg = ''
      if (param === 1) {
        confirmMsg = '確定納期日を更新しますがよろしいですか？'
      } else {
        confirmMsg = '回答作業日を更新しますがよろしいですか？'
      }
      this.updateMessage = ''
      this.updateConstructionDateMessage = ''
      this.updateDeliDateMessage = ''
      AppUtil.showModal({
        messages: [confirmMsg],
        modalType: 'confirm',
        onOk: () => {
          this.onUpdateDate(param)
        }
      })
    },
    onUpdateDate: function (param) {
      let urlPart = ''
      let payload = {}
      if (param === 1) {
        if (this.deliDate === '') {
          this.updateMessage = ''
          this.updateConstructionDateMessage = ''
          this.updateDeliDateMessage = '確定納期日が未入力です。'
          return
        }
        // 確定納期日
        urlPart = '/detail/update/deliDate'
        payload = {
          orderCode: this.orderCode,
          updateDate: this.deliDate
        }
      } else {
        if (this.constDate === '') {
          this.updateMessage = ''
          this.updateDeliDateMessage = ''
          this.updateConstructionDateMessage = '回答作業日が未入力です。'
          return
        }
        // 回答作業日
        urlPart = '/detail/update/constDate'
        payload = {
          orderCode: this.orderCode,
          updateDate: this.constDate
        }
      }
      axios.post(API_URL.ORDER + urlPart, payload)
        .then(response => {
          if (response.data.data.errorMsg != null) {
            if (param === 1) {
              this.updateDeliDateMessage = response.data.data.errorMsg
            } else {
              this.updateConstructionDateMessage = response.data.data.errorMsg
            }
          } else {
            this.orderDetailData = response.data.data
            if (param === 1) {
              this.updateMessage = ''
              this.updateConstructionDateMessage = ''
              this.updateDeliDateMessage = '確定納期日を更新しました。'
              this.deliDate = ''
            } else {
              this.updateMessage = ''
              this.updateDeliDateMessage = ''
              this.updateConstructionDateMessage = '回答作業日を更新しました。'
              this.constDate = ''
            }
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    sizeName: function (w, h, d) {
      return w + '×' + h + '×' + d + '(mm)'
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    packagedSize: function (width, height, depth, value) {
      if (width && height && depth) {
        return (Number(width) + 20) + 'x' + (Number(height) + 20) + 'x' + (Number(depth) + 20) + 'mm'
      } else if (value) {
        return value
      }
      return ''
    },
    getImage: function (image) {
      return AppUtil.getDarosResource(image)
    }
  },
  created: function () {
    this.orderCode = this.$route.query.id ? this.$route.query.id : undefined
    // if (this.$route.params.orderCode != null) {
    //   this.orderCode = this.$route.params.orderCode
    //   localStorage.setItem('OrderCode', JSON.stringify(this.$route.params.orderCode))
    // } else {
    //   this.orderCode = JSON.parse(localStorage.getItem('OrderCode'))
    // }
    this.getOrderDetail()

    let user = AppUtil.getLocalStorage(STORAGE_KEY.USER_INFO)
    this.userType = user.userType
  },
  computed: {
    isPreviewFile: function () {
      // return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.PLAN.code
      return true
    },
    isBomFile: function () {
      // return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType !== OBJECT_TYPE.UNIT.code
      return true
    },
    isUnit: function () {
      // return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.UNIT.code
      return true
    },
    isPlan: function () {
      // return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.PLAN.code
      return true
    },
    isEstimateFile: function () {
      // return this.fileData && Object.keys(this.fileData).length && Object.keys(this.fileData.topSpaceModel).length && this.fileData.topSpaceModel.spaceObjectType === OBJECT_TYPE.PLAN.code
      return true
    },
    isDelivery: function () {
      if (this.userType === USER_TYPE.DELIVERY.code) {
        return true
      }
      return false
    },
    isBuildingResearchData: function () {
      return this.builResrchData && Object.keys(this.builResrchData).length > 0
    },
    selectColorCnt: function () {
      let count = 0
      if (!this.orderDetailData || Object.keys(this.orderDetailData).length <= 0) return count
      if (this.orderDetailData.colorDoor) count += 1
      if (this.orderDetailData.colorCabine) count += 1
      if (this.orderDetailData.colorCounter) count += 1
      return count
    },
    firstColorLabel: function () {
      if (this.orderDetailData.colorDoor) return '2-1.扉カラー'
      if (this.orderDetailData.colorCabine) return '2-1.キャビネット/棚/脚カラー'
      if (this.orderDetailData.colorCounter) return '2-1.カウンターカラー'
      return ''
    },
    firstColorValue: function () {
      if (this.orderDetailData.colorDoor) return this.orderDetailData.colorDoor
      if (this.orderDetailData.colorCabine) return this.orderDetailData.colorCabine
      if (this.orderDetailData.colorCounter) return this.orderDetailData.colorCounter
      return ''
    },
    secondColorLabel: function () {
      if (this.orderDetailData.colorDoor) {
        if (this.orderDetailData.colorCabine) return '2-2.キャビネット/棚/脚カラー'
      } else {
        if (this.orderDetailData.colorCounter) return '2-2.カウンターカラー'
      }
      return ''
    },
    secondColorValue: function () {
      if (this.orderDetailData.colorDoor) {
        // 扉カラーが存在し、キャビネットカラーが2番目に来るケース
        if (this.orderDetailData.colorCabine) return this.orderDetailData.colorCabine
        // カウンターカラーが２番目に来るケース
        if (this.orderDetailData.colorCounter) return this.orderDetailData.colorCounter
      } else {
        // 扉カラーが存在せず、2-1.にキャビネット棚カラーが選択されたケース
        if (this.orderDetailData.colorCounter) return this.orderDetailData.colorCounter
      }
    },
    thirdColorLabel: function () {
      if (this.orderDetailData.colorCounter) return '2-3.カウンターカラー'
      return ''
    },
    thirdColorValue: function () {
      if (this.orderDetailData.colorCounter) return this.orderDetailData.colorCounter
      return ''
    }
  }
}
</script>
<!--<style src="../css/planning/side_tab_nav.scss" lang="scss" scoped></style>-->
<style src="../css/order/orderDetail.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/OrderDetail.vue